<template>
  <MasonryWall
    :items="photoItems"
    :ssr-columns="2"
    :gap="8"
    :min-columns="2"
    :max-columns="4"
    class="mt-2"
  >
    <template #default="masonryItem">
      <div
        role="button"
        tabindex="0"
        data-test="photoItem"
        class="block bg-gray-100 relative h-0 overflow-hidden cursor-pointer"
        :style="
          calculateAspectRatio(masonryItem.item.height, masonryItem.item.width)
        "
        @click.prevent="openPhotoLightbox(masonryItem.index)"
        @keydown.enter="openPhotoLightbox(masonryItem.index)"
      >
        <TLazyimg
          :ref="
            element => {
              if (element) imageRefs[masonryItem.index] = element
            }
          "
          :alt="masonryItem.item.alt"
          :sources="{ url: masonryItem.item.url }"
          classes-img="block w-full h-full object-cover"
          draggable="false"
          provider="directProvider"
        />
      </div>
    </template>
  </MasonryWall>
</template>

<script setup lang="ts">
import MasonryWall from '@yeger/vue-masonry-wall'

import PhotoSwipeLightbox from 'photoswipe/lightbox'
import type { DataSource } from 'photoswipe/lightbox'
import PhotoSwipeDynamicCaption from 'photoswipe-dynamic-caption-plugin'
import 'photoswipe/style.css'
import 'photoswipe-dynamic-caption-plugin/photoswipe-dynamic-caption-plugin.css'

import type { CottagePhotoItemType } from '../../entities/Cottage'

const imageRefs = ref<any[]>([])

export interface propsInterface {
  photoItems: CottagePhotoItemType[]
  currentIndex: number
}

const props = defineProps<propsInterface>()

const calculateAspectRatio = (height: number, width: number) => {
  const value = (height / width) * 100

  return {
    'padding-bottom': `${value}%`,
  }
}

const openPhotoLightbox = (index: number) => {
  const galleryNodeList: DataSource = props.photoItems.map(image => ({
    src: image.url,
    width: image.width,
    height: image.height,
    description: image.alt,
  }))

  const lightbox = new PhotoSwipeLightbox({
    dataSource: galleryNodeList,
    showHideAnimationType: 'fade',
    pswpModule: () => import('photoswipe'),
  })

  new PhotoSwipeDynamicCaption(lightbox, {
    type: 'below',
    captionContent: (slide: any) => slide.data.description,
  })

  lightbox.init()
  lightbox.loadAndOpen(index)
}

const scrollTo = () => {
  const index = props.currentIndex

  if (imageRefs.value[index]) {
    imageRefs.value[index].$el.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
      inline: 'nearest',
    })
  }
}

onMounted(() => {
  setTimeout(() => {
    scrollTo()
  }, 900)
})
</script>
